import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

const HomePage: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || "en";
  
  // ホームページはtranscriptionページにリダイレクト
  return <Navigate to={`/${currentLang}/transcription`} />;
};

export default HomePage; 